/**
 * Discriminates the two behaviours of a Parallel AI source. Mirrors the backend
 * `ParallelAiType` enum (apps/api/src/parallel-ai/enums/parallel-ai-type.enum.ts).
 */
export enum ParallelAiType {
	SEARCH = "SEARCH",
	MONITOR = "MONITOR",
}

/** Monitor execution cadence, in Parallel Monitor API format. */
export enum ParallelAiMonitorFrequency {
	HOURLY = "1h",
	DAILY = "1d",
	WEEKLY = "1w",
}

/** Monitor processor tier. */
export enum ParallelAiMonitorProcessor {
	LITE = "lite",
	BASE = "base",
}
